import { lectio } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { isFeaturedArticlesLoaded } from '../selectors/featured-articles';

export const fetchFeaturedArticles = () => {
  return async (dispatch, getState) => {
    if (isFeaturedArticlesLoaded(getState())) return;
    try {
      const { data: featuredArticles } = await lectio.get(`/articles/featured`);
      return dispatch({
        type: ActionTypes.FETCH_FEATURED_ARTICLES_SUCCESS,
        payload: featuredArticles
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_FEATURED_ARTICLES_NOT_FOUND
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_FEATURED_ARTICLES_ERROR
      });
    }
  };
};
